<template>
  <div class="partial-list pt-2">
    <template v-if="filteredCarriers.length">
      <span class="divider"></span>
      <div class="partial-list__content">
        <div class="partial-list__title">
          <p class="trucs-list__type">Your partial options</p>
        </div>
        <div class="partial-container" id="partial-container" v-if="screenWidth > 800">
          <template v-if="carriersImages">
            <OptionsComponent
              v-for="(partial, index) in filteredCarriers"
              :key="index"
              :carrier="partial"
              :carrierImage="findCarrierImage(partial)"
              :aditionalInsurance="aditionalInsurance"
              :loadingInsurance="loadingInsurance"
              :isPartial="true"
              :originalCarrierArray="originalCarrierArray"
              @optionSelected="optionSelected"
              class="mb-3"
            ></OptionsComponent>
          </template>
          <template v-if="partial.length === 0 && !allNotificationsObtained">
            <p>We are working to obtain partial carriers. This may take some time.</p>
            <b-spinner small label="Spinning"></b-spinner>
          </template>
          <div class="not-carriers">
            <p v-if="partial.length === 0 && allNotificationsObtained && !isBranded">
              {{ $t("carriers.noCarriersFound") }}
            </p>
            <p v-if="partial.length === 0 && allNotificationsObtained && isBranded">
              {{ $t("carriers.noCarriersFoundBranding") }}
            </p>
          </div>
        </div>
        <div class="partial-container" id="partial-container" v-if="screenWidth <= 800">
          <template v-if="carriersImages">
            <OptionsComponentResponsive
              v-for="(partial, index) in filteredCarriers"
              :key="index"
              :carrier="partial"
              :carrierImage="findCarrierImage(partial)"
              :aditionalInsurance="aditionalInsurance"
              :loadingInsurance="loadingInsurance"
              :originalCarrierArray="originalCarrierArray"
              :isPartial="true"
              @optionSelected="optionSelected"
              class="mb-3"
            >
            </OptionsComponentResponsive>
          </template>
          <template v-if="partial.length === 0 && !allNotificationsObtained">
            <p>We are working to obtain partial carriers. This may take some time.</p>
            <b-spinner small label="Spinning"></b-spinner>
          </template>
          <div class="not-carriers">
            <p v-if="partial.length === 0 && allNotificationsObtained && !isBranded">
              {{ $t("carriers.noCarriersFound") }}
            </p>
            <p v-if="partial.length === 0 && allNotificationsObtained && isBranded">
              {{ $t("carriers.noCarriersFoundBranding") }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import onReSize from "@/Extend/onResize";
import OptionsComponent from "../CarriersOptions/OptionsComponent.vue";
import OptionsComponentResponsive from "../CarriersOptions/OptionsComponentResponsive.vue";
import UpdateAditionalInsurance from "../../../../../../../utils/updateAditionalInsurance";

export default {
  name: "Partial",
  mixins: [onReSize],
  props: {
    partial: Array,
    allNotificationsObtained: Boolean,
    filterByGuaranteed: Boolean,
    originalCarrierArray: Array
  },
  components: {
    OptionsComponent,
    OptionsComponentResponsive,
  },
  data() {
    return {
      filteredCarriers: [],
      aditionalInsurance: 35,
      loadingInsurance: false,
      carrierSelected: null,
      chosenLoad: null,
      isBranded: false,
    };
  },
  created() {
    this.chosenLoad = this.$store.getters["load/getChosenLoad"];
    const cargoValue = this.$store.getters["carriers/getChosenLoadCargoValue"];
    this.isBranded = this.$store.getters["login/getTokenInfo"].is_branded;
    this.aditionalInsurance = UpdateAditionalInsurance(
      cargoValue,
      this.$store.getters["carriers/getInsuranceCoveragePlan"]
    );
    if (this.filterByGuaranteed) {
      this.filteredCarriers = this.filterCarriersByGuaranteed(this.partial);
    }
  },
  watch: {
    partial: {
      immediate: true,
      handler() {
        this.filteredCarriers = [...this.partial];
      },
    },
    chosenLoadCargoValue() {
      this.aditionalInsurance = UpdateAditionalInsurance(
        this.chosenLoadCargoValue,
        this.insuranceCoveragePlan
      );
    },
    insuranceCoveragePlan() {
      this.aditionalInsurance = UpdateAditionalInsurance(
        this.chosenLoadCargoValue,
        this.insuranceCoveragePlan
      );
    },
  },
  computed: {
    ...mapGetters({
      chosenLoadCargoValue: "carriers/getChosenLoadCargoValue",
      insuranceCoveragePlan: "carriers/getInsuranceCoveragePlan",
      carriersImages: "carriers/getCarriersImages",
    }),
  },
  methods: {
    findCarrierImage(partial) {
      if (partial.logo) {
        return { url: partial.logo, carrier: partial.carrier || "" };
      }
      const newImage = this.carriersImages.find(
        (image) => image && image.name && partial.carrier && image.name.includes(partial.carrier)
      );
      if (newImage) {
        return newImage;
      }
      return { url: "" };
    },
    async optionSelected(params) {
      this.carrierSelected = params.carrierId;
      this.chosenLoad.insurance_required = params.isInsurance;
      this.chosenLoad.carrierName = params.carrierName;
      this.$store.commit("load/setChosenLoad", this.chosenLoad);
      if (params.changeView) {
        this.$store.commit("carriers/disconnectSocket");
        this.changeView("StopsInfo", params.loyaltyInsurance, params.pickup, params.isInsurance);
      }
      this.loadingInsurance = false;
    },
    filterCarriersByGuaranteed(carriers) {
      return carriers.filter((carrier) => {
        const serviceClass = carrier.serviceClass.toLowerCase();
        const serviceClassList = ["guaranteed", "expedited", "time critical", "accelerated"];
        return serviceClassList.some((item) => serviceClass.includes(item));
      });
    },
    changeView(routeName, loyaltyInsurance, pickup, insurance) {
      const id = this.carrierSelected;
      this.$router.push({
        name: routeName,
        params: {
          loadId: this.$route.params.loadId,
          carrierId: id,
          insurance
        },
        query: {
          pickup,
          insurance,
          ...(loyaltyInsurance === true && { loyaltyInsurance: true })
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
.partial-list {
  &__content {
    width: 98%;
    margin: 20px auto;
  }
  &__type {
    margin: 0px;
  }
  &__title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 1rem;
    p {
      color: $color-primary-company;
      @include font-standart-text;
      font-weight: bold;
    }
    @media (max-width: 800px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 5%;
      p {
        color: $color-primary-company;
        font-weight: bold;
        margin: 0;
        margin-bottom: 3%;
      }
    }
  }
}

.divider {
  display: inline-block;
  width: 100%;
  height: 0;
  border-bottom: 1px solid $color-border-container;
  @media (max-width: 800px) {
    margin: 3% 0 4% 0;
  }
}
</style>
